import keys from './es.json';

const monthsParse = [
    /^ene/i,
    /^feb/i,
    /^mar/i,
    /^abr/i,
    /^may/i,
    /^jun/i,
    /^jul/i,
    /^ago/i,
    /^sep/i,
    /^oct/i,
    /^nov/i,
    /^dic/i,
  ],
  monthsRegex =
    /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre|ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i;

/*
//TODO
function processRelativeTime(number, withoutSuffix, key, isFuture) {
  var format = {
    'm': ['one minute', 'einer Minute'],
    'h': ['eine Stunde', 'einer Stunde'],
    'd': ['ein Tag', 'einem Tag'],
    'dd': [number + ' Tage', number + ' Tagen'],
    'M': ['ein Monat', 'einem Monat'],
    'MM': [number + ' Monate', number + ' Monaten'],
    'y': ['ein Jahr', 'einem Jahr'],
    'yy': [number + ' Jahre', number + ' Jahren']
  };
  return withoutSuffix ? format[key][0] : format[key][1];
}
*/

export default {
  locale: 'es',
  messages: {
    ...keys,
    'RoundDateDisplay::format': `{ hasEnd, select,
      true {
        { preposition, select,
          at { at { end } }
          until { until { end } }
        }
      }
      other { { duration, plural,
          one { # Day }
          other { # Days }
        }
      }
    }`,
    statusvalue: `{ whitelistedAgentStatus, select,
      requested { Participation requested }
      blocked { Access blocked }
      other {

        { roundNumber, select,
          0 {
            { content, select,
              Preview { Preview }
              Resolved { Resolved }
              other { {content} }
            }
          }
          other {
            { roundType, select,
              counteroffer_bidding { Contraoferta }
              incremental_auction { Ofertas flexibles }
              open_bidding { Ofertas abiertas }
              registration { Invitación }
              sealed_bidding { Ofertas cerrada }
              simple_offer { Ofertas individuales }
            }
            ronda
            { roundNumber }
            { roundStatus, select,
              opened { abierta }
              started { comenzada }
              closed { cerrada }
              other { {roundStatus} }
            }
          }
        }
      }
    }`,
    'RoundInfo::label': `
      { type, select,
        sealed_bidding { Ofertas cerrada }
        open_bidding { Ofertas flexibles }
        incremental_auction { Ofertas flexibles }
        counteroffer_bidding { Contraoferta }
        registration { Invitación }
        simple_offer { Ofertas individuales }
      }
      ronda
      { number }
      { status, select,
        started { aún no abierta }
        opened
        {
          {
            durationType, select,
              fixed {
                { isPreview, select,
                  true { comienza {startDuration} }
                  false {
                    { isPast, select,
                      false { termina {endDuration} }
                      other { ha terminado }
                    }
                  }
                }
              }
              flexible { termina en {durationInDays} dias }
          }
        }
        closed { finalizó el { endText } }
        other { {status} }
      }
    `,
  },

  moment: {
    months:
      'enero_febrero_marzo_abril_mayo_junio_julio_agosto_septiembre_octubre_noviembre_diciembre'.split(
        '_'
      ),
    monthsShort:
      'ene._feb._mar._abr._may._jun._jul._ago._sep._oct._nov._dic.'.split('_'),
    monthsRegex: monthsRegex,
    monthsShortRegex: monthsRegex,
    monthsStrictRegex:
      /^(enero|febrero|marzo|abril|mayo|junio|julio|agosto|septiembre|octubre|noviembre|diciembre)/i,
    monthsShortStrictRegex:
      /^(ene\.?|feb\.?|mar\.?|abr\.?|may\.?|jun\.?|jul\.?|ago\.?|sep\.?|oct\.?|nov\.?|dic\.?)/i,
    monthsParse: monthsParse,
    longMonthsParse: monthsParse,
    shortMonthsParse: monthsParse,
    weekdays: 'domingo_lunes_martes_miércoles_jueves_viernes_sábado'.split('_'),
    weekdaysShort: 'dom._lun._mar._mié._jue._vie._sáb.'.split('_'),
    weekdaysMin: 'do_lu_ma_mi_ju_vi_sá'.split('_'),
    weekdaysParseExact: true,
    longDateFormat: {
      LT: 'H:mm',
      LTS: 'H:mm:ss',
      L: 'DD/MM/YYYY',
      LL: 'D [de] MMMM [de] YYYY',
      LLL: 'D [de] MMMM [de] YYYY H:mm',
      LLLL: 'dddd, D [de] MMMM [de] YYYY H:mm',
    },
    calendar: {
      sameDay: function () {
        return '[hoy a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
      },
      nextDay: function () {
        return '[mañana a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
      },
      nextWeek: function () {
        return 'dddd [a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
      },
      lastDay: function () {
        return '[ayer a la' + (this.hours() !== 1 ? 's' : '') + '] LT';
      },
      lastWeek: function () {
        return (
          '[el] dddd [pasado a la' + (this.hours() !== 1 ? 's' : '') + '] LT'
        );
      },
      sameElse: 'L',
    },
    relativeTime: {
      future: 'en %s',
      past: 'hace %s',
      s: 'unos segundos',
      ss: '%d segundos',
      m: 'un minuto',
      mm: '%d minutos',
      h: 'una hora',
      hh: '%d horas',
      d: 'un día',
      dd: '%d días',
      w: 'una semana',
      ww: '%d semanas',
      M: 'un mes',
      MM: '%d meses',
      y: 'un año',
      yy: '%d años',
    },
    dayOfMonthOrdinalParse: /\d{1,2}º/,
    ordinal: '%dº',
    week: {
      dow: 1, // Monday is the first day of the week.
      doy: 4, // The week that contains Jan 4th is the first week of the year.
    },
    invalidDate: 'Fecha inválida',
  },
};



// WEBPACK FOOTER //
// ./src/app/locales/es.js